import { ReactNode } from 'react';
import Grid from '@mui/material/Grid';
import { useTranslation } from 'react-i18next';
import CountrySelect from './CountryFilter';
import OakBrookMonthFilter from './OakBrookMonthFilter';
import { AppPermissions } from '../../../types';
import { PermissionsProvider } from '../../Permissions';
import { FilterPanel, StatusChip } from '../../Visual';

export interface OakBrookFiltersProps {
  actions: ReactNode;
  applyDisabled: boolean;
  countryRequiredIncomplete: boolean;
  monthRequiredIncomplete: boolean;
}

const OakBrookFilters = ({
  actions,
  applyDisabled,
  countryRequiredIncomplete,
  monthRequiredIncomplete,
}: OakBrookFiltersProps) => {
  const { t } = useTranslation();

  return (
    <PermissionsProvider resourcePermissions={[AppPermissions.OAK_BROOK_SALES]}>
      <FilterPanel
        subtitleTranslationKey="oak-brook.filters.subtitle"
        actions={
          <StatusChip
            status={applyDisabled ? 'warning' : 'success'}
            label={applyDisabled ? t('filters.status.missingRequired') : t('filters.status.ready')}
          />
        }
      >
        <Grid container spacing={3} alignItems="flex-end">
          <Grid item xs={12} md={4} lg={2} xl={2}>
            <CountrySelect fullWidth requiredIncomplete={countryRequiredIncomplete} />
          </Grid>
          <Grid item xs={12} md={4} lg={2} xl={2}>
            <OakBrookMonthFilter requiredIncomplete={monthRequiredIncomplete} />
          </Grid>
          <Grid item xs={12} md lg xl>
            {actions}
          </Grid>
        </Grid>
      </FilterPanel>
    </PermissionsProvider>
  );
};

export default OakBrookFilters;
